// removed by extract-text-webpack-plugin
module.exports = {"RelatedVideo__container":"RelatedVideo__container","RelatedVideo__main_title":"RelatedVideo__main_title","RelatedVideo__wrap":"RelatedVideo__wrap","RelatedVideo":"RelatedVideo","RelatedVideo__link":"RelatedVideo__link","RelatedVideo__thumb":"RelatedVideo__thumb","RelatedVideo__thumb__block":"RelatedVideo__thumb__block","RelatedVideo__text":"RelatedVideo__text","RelatedVideo__pcTitle":"RelatedVideo__pcTitle","RelatedVideo__pcDescription":"RelatedVideo__pcDescription","RelatedVideo__mbTitle":"RelatedVideo__mbTitle","RelatedVideo__mbDescription":"RelatedVideo__mbDescription"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/related-video/styles.css
// module id = 744
// module chunks = 0 1